import { render, staticRenderFns } from "./UjianStart.vue?vue&type=template&id=adcf6fb0&scoped=true"
import script from "./UjianStart.vue?vue&type=script&lang=js"
export * from "./UjianStart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "adcf6fb0",
  null
  
)

export default component.exports